module.exports = __webpack_public_path__ + "img/lg_ring_y_l_null_1@2x.714581e9.png";